export default [
  {
    text: "国网江苏省电力有限公司关于2024年9月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-9.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年8月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-8.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年7月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-7.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年6月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-6.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年5月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-5.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年4月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-4.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年3月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-3.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年2月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-2.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2024年1月代理购电工商业用户电",
    url: "/pdf/electrictPbz/24-1.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年12月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-12.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年11月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-11.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年10月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-10.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年9月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-9.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年8月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-8.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年7月代理购电工商业用户电",
    url: "/pdf/electrictPbz/23-7.pdf",
  },
  {
    text: "省友展改革委美子逃一歩完善分吋屯倫机制有美事項的通知（尖峰电价）",
    url: "/pdf/electrictPbz/jf1.pdf",
  },
  {
    text: "2021年尖峰电价（尖峰电价）",
    url: "/pdf/electrictPbz/jf2.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年6月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl1.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年5月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl2.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年4月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl3.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年3月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl4.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年2月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl5.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2023年1月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl6.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年12月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl7.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年11月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl8.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年10月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl9.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年9月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl10.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年8月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl11.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年7月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl12.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年6月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl13.pdf",
  },
  {
    text: "国网江苏省电力有限公司关于2022年5月代理购电工商业用户电价的公告（代理购电）",
    url: "/pdf/electrictPbz/dl14.pdf",
  },
  {
    text: "江苏电网2020-2022年输配电价和销售电价有关事项通知（销售电价表）",
    url: "/pdf/electrictPbz/xs1.pdf",
  },
  {
    text: "关于进一步做好深化燃煤发电上网电价市场化改革工作的通知（销售电价表）",
    url: "/pdf/electrictPbz/xs2.pdf",
  },
  {
    text: "2021年销售电价（销售电价表）",
    url: "/pdf/electrictPbz/xs3.pdf",
  },
];
